import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getPaymentTerms = async () => {
  return await get<ApiResponse<any[]>>("/paymentterms").then((res) => res);
};

